export enum INTEGRATION_BC_CHANNELS {
  PODIUM = 'podium_integration_success',
}

export enum INTEGRATION_BC_TYPES {
  PODIUM = 'podium_oauth_success',
}

export enum INTEGRATION_TYPE {
  PODIUM = 'podium',
}
